<h1>{{'SENSITIVITY.RESULTS.HEADER' | anessaTranslation: trigger}}</h1>

<div class="fl">
   <!-- Parameters Select -->
  <div class="fl-item max-width-33">
    <mat-form-field floatLabel="never" class="anessa-dropdown">
      <mat-select
        id="sensitivity-result-parameters_select"
        disableOptionCentering
        multiple
        [placeholder]="'SENSITIVITY.RESULTS.SELECTED_PARAMS_PLACEHOLDER' | anessaTranslation: trigger"
        [(value)]="selectedParameters"
        (valueChange)="optionsChanged()"
        panelClass="anessa-dropdown-panel">

        <mat-checkbox
        class="mat-option mat-option-multi"
        color="primary"
        (change)="inputsCheckAll($event)"
        [checked]="allInputsSelected()"
        [indeterminate]="isCheckAllIndeterminate()"
        #inputsCheckbox>{{
          (inputsCheckbox.checked ? 'RESULTS.GENERAL.DESELECT_ALL' : 'RESULTS.GENERAL.SELECT_ALL')
            | anessaTranslation: trigger
          }}</mat-checkbox>
        <ng-container *ngFor="let type of parameters">
          <mat-option
          style="padding-left:10px;"
            [value]="type"
            [matTooltip]="type"
          >
            {{inputTranslations[type]}}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>
   <!-- Result Set Select -->
  <div class="fl-item">
    <mat-form-field floatLabel="never" class="anessa-dropdown">
      <mat-select
        id="sensitivity-result-resultSet_select"
        disableOptionCentering
        [placeholder]="'SENSITIVITY.RESULTS.SELECTED_RESULT_SET' | anessaTranslation: trigger"
        [(value)]="selectedResult"
        (valueChange)="optionsChanged()"
        panelClass="anessa-dropdown-panel">
        <ng-container *ngFor="let type of resultTypes">
          <mat-option
            [value]="type"
          >
            {{ type | anessaTranslation: trigger}}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>
   <!-- Set Unit Select -->
  <div class="fl-item" *ngIf="showUnitTypeDropdown()">
    <mat-form-field floatLabel="never" class="anessa-dropdown">
      <mat-select
        id="sensitivity-result-setUnit_select"
        disableOptionCentering
        [placeholder]="'RESULTS.GENERAL.SET_UNIT_LOCAL' | anessaTranslation: trigger"
        [(value)]="selectedUnitsType"
        (valueChange)="optionsChanged()"
        panelClass="anessa-dropdown-panel">
        <ng-container *ngFor="let type of unitsTypes">
          <mat-option
            [value]="type.value"
          >
            {{ type.translationId | anessaTranslation: trigger}}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>
   <!-- Currency Select -->
  <div class="fl-item" *ngIf="currencyUnitsLoaded && showCurrencyUnitsDropdown()">
    <mat-form-field floatLabel="never" class="anessa-dropdown">
      <mat-select
        id="sensitivity-result-currency_select"
        disableOptionCentering
        [placeholder]="'RESULTS.GENERAL.SET_CURRENCY' | anessaTranslation: trigger"
        [(value)]="selectedCurrencyUnit"
        (valueChange)="optionsChanged()"
        panelClass="anessa-dropdown-panel">
        <ng-container *ngFor="let unit of currencyUnits">
          <mat-option
            [value]="unit"
          >
            {{ unit.translationId | anessaTranslation: trigger }}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>

  <img class="calculator-image" (click)="showPopUp()"
    src="../../../../assets/SensitivitySolver/calculator.svg"
    alt="Sensitivity Solver"
    [matTooltip]="( 'SENSITIVITY.AI.tooltip' | anessaTranslation: trigger )">
</div>

<div class="fl" *ngIf="showChart">
  <p>{{'RESULTS.GENERAL.EXCHANGE_RATES_FROM' | anessaTranslation: trigger}} <i>{{ exchangeRateDate }}</i></p>
</div>

<div *ngIf="showChart">
  <app-graph-selector
    [idPrefix]="'sensitvity-result-graph'"
    [hideSaveButtons]="false"
    [graphData]="curGraphData"
    [customLayout]="graphLayout"
    [graphType]="'multitrace'"
    [graphLabel]="'SENSITIVITY.RESULTS.GRAPH_LABEL' | anessaTranslation: trigger"
    [xAxisLabel]="'SENSITIVITY.RESULTS.GRAPH_X_AXIS_LABEL' | anessaTranslation: trigger"
    [yAxisLabel]="yAxisLabel"
    [saveGraphAsImage]="true"
  ></app-graph-selector>
</div>

<div *ngIf="showTable">
  <results-treetable
    [idPrefix]="'sensitvity-result-table'"
    [labelKey]="'SENSITIVITY.RESULTS.VARIABLE_HEADER'"
    [valueKey]="'SENSITIVITY.RESULTS.BASELINE_VALUE_HEADER'"
    [firstColumnHeader]="'SENSITIVITY.RESULTS.VARIABLE_HEADER' | anessaTranslation: trigger"
    [customColumnOrder]="tableHeaders"
    [resultsData]="tableData"
  ></results-treetable>
</div>
